import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionTitle: {
		id: 'fastshift.dc-instance-details.assessment-overview.title',
		defaultMessage: 'Cloud readiness overview',
		description: 'Heading for the Cloud readiness assessment overview.',
	},
	assessedAt: {
		id: 'fastshift.dc-instance-details.assessment-overview.assessed-at',
		defaultMessage: 'Assessed at {date}',
		description: 'Date of the Cloud readiness assessment.',
	},
	totalChecks: {
		id: 'fastshift.dc-instance-details.assessment-overview.total-checks',
		defaultMessage: 'Total checks',
		description: 'Number of all assessment checks, including skipped checks.',
	},
	needsAttention: {
		id: 'fastshift.dc-instance-details.assessment-overview.needs-attention',
		defaultMessage: 'Needs attention',
		description: 'Number of high and medium risk assessment checks.',
	},
	passed: {
		id: 'fastshift.dc-instance-details.assessment-overview.passed',
		defaultMessage: 'Passed',
		description: 'Number of low risk assessment checks.',
	},
	loading: {
		id: 'fastshift.dc-instance-details.assessment-overview.loading',
		defaultMessage: 'Loading Cloud readiness overview',
		description: 'Accessible loading announcement for the assessment overview.',
	},
});
